import { render, staticRenderFns } from "./index.vue?vue&type=template&id=57ef4fac&"
import script from "./index.vue?vue&type=script&lang=ts&setup=true&"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ef4fac')) {
      api.createRecord('57ef4fac', component.options)
    } else {
      api.reload('57ef4fac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=57ef4fac&", function () {
      api.rerender('57ef4fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/info/ethical-commission/index.vue"
export default component.exports